import { useCallback } from 'react';

import { formatReferenceViewID } from '../../modules/referenceView/index.ts';
import { setActiveID } from '../../redux/features/referenceBarUISlice.ts';
import { useAppDispatch } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarProperty } from '../types.ts';
import { useActiveReferenceBarID } from './useActiveReferenceBarID.ts';

// FIXME: move this out of the controller, perhaps with the reference bar component
export const useTkv2UpdateReferenceBarProperties = (): ((
  property: Tkv2ReferenceBarProperty,
) => void) => {
  const activeID = useActiveReferenceBarID();
  const dispatch = useAppDispatch();

  return useCallback(
    ({ id }: Tkv2ReferenceBarProperty) => {
      const isIDUnchanged = id && id === activeID;
      if (isIDUnchanged) {
        return;
      }

      dispatch(setActiveID(id ?? formatReferenceViewID({ type: 'subject' })));
    },
    [activeID, dispatch],
  );
};
